import { OfferCard } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { useAppSelector } from '@/store';

import type { TBankOffers } from '../../types/bank-offer.types';

type TBankWaitingItemProps = {
  bankOffer: TBankOffers;
};

const BankWaitingItem = ({ bankOffer }: TBankWaitingItemProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const bank = dicts?.[DictTypes.Banks]?.getBy.name[bankOffer.bank.name];
  const bankIconName = BANKS_ICONS_NAMES[bankOffer.bank.name];

  const name = bank?.fullname || bankIconName?.name;
  const icon = bank?.icon || bankIconName?.icon;

  if (!name) return null;
  return (
    <OfferCard
      className="bank-item"
      status="warning"
      statusText={bankOffer.status.name}
      extId={bankOffer.extId || undefined}
    >
      <OfferCard.Header
        title={name}
        icon={icon}
        isWaitingOffer
        requestBodyInfo={{
          bankName: bankOffer.bank.name,
          responsePrimaryBody: bankOffer.responsePrimaryBody,
          responseSendedBody: bankOffer.responseSendedBody
        }}
      />
    </OfferCard>
  );
};

export default BankWaitingItem;
